<template>
  <div class="askQuestion">
    <div class="activity-header-container">
      <div
        class="activity-header"
        :style="{
          paddingTop: stateHeight,
        }"
      >
        <van-nav-bar :border="false" :title="title" class="navbar" placeholder>
          <template #left>
            <div class="left">
              <img
                v-if="showBack"
                class="icon-back"
                src="../assets/img/activity/icon-back.png"
                @click="handleBack"
              />
            </div>
          </template>
          <template #title>
            <span>{{ showTitle ? title : "" }}</span>
          </template>
          <template #right>
            <div
              class="publish"
              @click="handlePublish"
              :style="{ opacity: loading ? 0.5 : 1 }"
            >
              发布
            </div>
          </template>
        </van-nav-bar>
      </div>
    </div>
    <!--提问题-->
    <div v-show="isFromAskQuestions">
      <div
        class="qst_con"
        :style="{
          paddingTop: parseInt(stateHeight) + 48 + 'px',
        }"
      >
        <div class="questiontext" v-show="isComOrJobShow">
          <span
            :class="{
              icon: true,
              job: linkData.type == 3,
              com: linkData.type == 2,
            }"
          ></span>
          <span v-show="linkData.type == 2">{{
            linkData.coName ? linkData.coName : ""
          }}</span>
          <span v-show="linkData.type == 3" class="questiontext_com">
            <span class="jobName">{{ linkData.jobName }}</span>
            <span v-show="linkData.jobName && linkData.coName" class="dot"
              >·</span
            >
            <span class="coName">{{ linkData.coName }}</span>
            <span class="provideSalaryString">{{
              linkData.provideSalaryString
            }}</span>
          </span>
        </div>
        <div class="qstarea">
          <label for="myTextarea"></label>
          <textarea
            id="myTextarea"
            class="qsttext"
            rows="5"
            cols="50"
            placeholder="准确描述问题，更能获得有效的帮助哦～"
            v-model="qstText"
          ></textarea>
          <div class="wordlimit">{{ qstRemainingCount }} / 100</div>
        </div>
        <div class="guess">猜你想问</div>
      </div>
      <div class="guest_con">
        <div
          class="guessList"
          ref="guessListRef"
          v-for="(item, index) in guessList"
          :key="index"
          :style="{ marinRight: item.isWholeline ? '0' : '8px' }"
          @click="handleClick(item)"
        >
          <div class="g_item">
            <span class="g_icon"></span>
            <span class="g_item_text">{{ item }}</span>
          </div>
        </div>
      </div>
    </div>
    <!--回答问题-->
    <div v-show="!isFromAskQuestions">
      <div
        class="qst_con"
        :style="{
          paddingTop: parseInt(stateHeight) + 48 + 'px',
        }"
      >
        <div class="question">
          <span class="qst_icon"></span>
          <span class="qst_name">{{ $route.query.question }}</span>
        </div>
        <div class="qstarea">
          <label for="myTextarea"></label>
          <textarea
            id="myTextarea"
            class="qsttext answertext"
            rows=""
            cols="50"
            placeholder="点击输入文字"
            v-model="answerText"
          ></textarea>
          <div class="wordlimit">{{ answerRemainingCount }} / 500</div>
        </div>
        <!-- <div class="guess">猜你想问</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import jsonData from "@/assets/json/data.json";
export default {
  name: "AskQuestion",
  data() {
    return {
      loading: false,
      title: this.$route.query?.isFromQuestionDetail ? "写回答" : "提问题",
      showBack: true,
      showTitle: true,
      isComOrJobShow: false, //公司或职位提问展示
      questiontext: "外卖骑手·上海益海餐饮管理公司·6-12元/单",
      guessList: [],
      qstText: "", // 提问题
      answerText: "", //回答
      message: "",
      isWholeline: true,
      linkData: this.$route.query,
      isFromAskQuestions: this.$route.query?.isFromQuestionDetail
        ? false
        : true, // true:提问题 false:回答问题
      stateHeight: 0,
    };
  },
  computed: {
    qstRemainingCount() {
      return this.qstText.length;
    },
    answerRemainingCount() {
      return this.answerText.length;
    },
  },
  watch: {
    qstText(newValue) {
      if (newValue.length > 100) {
        this.qstText = newValue.slice(0, 100);
      }
    },
    answerText(newValue) {
      if (newValue.length > 500) {
        this.answerText = newValue.slice(0, 500);
      }
    },
  },
  created() {},
  async mounted() {
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    const extrParams = {
      2: {
        companyId: this.linkData?.coId,
      },
      3: {
        companyId: this.linkData?.coId,
        jobId: this.linkData?.jobId,
      },
    };
    this.$sensors.track("WidgetShow", {
      $element_id: "sensor_bcop_qaform",
      contentType: this.isFromAskQuestions ? "提问" : "回答",
      ...extrParams[this.linkData?.type],
    });
    // 1-根据活动提问；2-根据公司提问；3-根据职位提问
    this.guessList =
      this.linkData.type == "3"
        ? jsonData.jobAsk
        : this.linkData.type == "2"
        ? jsonData.companyAsk
        : jsonData.activityAsk;
    this.pickThree();
    this.isComOrJobShow =
      this.linkData?.type && this.linkData?.type != "1" ? true : false;
  },
  methods: {
    handleClick(data) {
      const extrParams = {
        2: {
          companyId: this.linkData?.coId,
        },
        3: {
          companyId: this.linkData?.coId,
          jobId: this.linkData?.jobId,
        },
      };
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_qaform_lookalike",
        contentName: data,
        ...extrParams[this.linkData?.type],
      });
      this.qstText += data;
    },
    // 随机打乱数组
    pickThree() {
      // 创建原始数组的拷贝，以免影响原始数组
      const shuffled = [...this.guessList];
      // 使用Fisher-Yates shuffle算法洗牌
      let i = shuffled.length;
      while (i > 0) {
        const j = Math.floor(Math.random() * i);
        i--;
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      // 从洗牌后的数组中取出前三个元素
      this.guessList = shuffled;
    },
    // 返回
    handleBack() {
      window.history.go(-1);
    },
    // 发布
    handlePublish() {
      if (this.loading) return;
      const extrParams = {
        2: {
          companyId: this.linkData?.coId,
        },
        3: {
          companyId: this.linkData?.coId,
          jobId: this.linkData?.jobId,
        },
      };
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_qaform_release",
        contentType: this.isFromAskQuestions ? "提问" : "回答",
        ...extrParams[this.linkData?.type],
      });
      const {
        type,
        activityId,
        componentId,
        coId,
        jobId,
        jobSource,
        originType,
      } = this.linkData;
      const idMap = {
        1: componentId,
        2: coId,
        3: jobId,
      };
      const newType = originType || type;
      if (this.isFromAskQuestions) {
        // 提问
        if (!this.qstText) {
          this.$toast("问题内容不能为空");
          return;
        }
        this.loading = true;
        let params = {
          activityId: this.linkData?.activityId,
          jobId: this.linkData?.jobId ? this.linkData?.jobId : "",
          coId: this.linkData?.coId ? this.linkData?.coId : "",
          type: this.linkData?.type, //1-根据活动提问；2-根据公司提问；3-根据职位提问
          content: this.qstText,
          ctmId: this.linkData?.ctmId,
          companyName: this.linkData?.coName,
          jobName: this.linkData?.jobName,
        };
        this.$api.activity
          .addQuestion(params)
          .then((res) => {
            if (res?.code == "0") {
              this.$toast("发布成功\n审核通过后显示");
              setTimeout(() => {
                this.$router.push({
                  path: "/questionAndAnswerList",
                  query: {
                    id: idMap[newType],
                    activityId,
                    componentId,
                    type: newType,
                    jobSource,
                  },
                });
              }, 1000);
            } else {
              this.$toast(res.msg);
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        // 回答
        if (!this.answerText) {
          this.$toast("回答内容不能为空");
          return;
        }
        this.loading = true;
        let params = {
          questionId: this.$route.query.questionId,
          content: this.answerText,
        };
        this.$api.activity
          .addAnswer(params)
          .then((res) => {
            if (res?.code == "0") {
              this.$toast("发布成功\n审核通过后显示");
              setTimeout(() => {
                // this.$router.push({
                //   path: "/questionDetail",
                //   query: {
                //     questionId: this.$route.query.questionId,
                //     activityId,
                //     type: newType,
                //     jobSource,
                //     componentId,
                //     originType: this.$route.query.originType,
                //     index: this.$route.query.index,
                //     formPage: this.$route.query.formPage,
                //     id: this.$route.query.id,
                //   },
                // });
                window.history.go(-1);
              }, 1000);
            } else {
              this.$toast(res.msg);
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style scoped lang="less">
* {
  overflow: hidden;
}
.askQuestion {
  background: #fff;
  min-height: 100vh;
  .activity-header-container {
    position: relative;
    .activity-header {
      min-height: 44px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      .pc & {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        width: 375px;
      }
      .left {
        display: flex;
      }
      /deep/.van-nav-bar {
        height: 44px;
        width: 100%;
        .van-nav-bar__content {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px 0 16px;
          position: relative;
          .van-nav-bar__title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
          }
        }
      }
      .icon-back {
        display: inline-block;
        width: 24px;
        height: 24px;
      }
      .publish {
        width: 61px;
        height: 24px;
        background: #ff6c0e;
        border-radius: 15px;
        color: #ffffff;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .qst_con {
    padding: 0 16px;
    .questiontext {
      // width: 100%;
      height: 28px;
      background: linear-gradient(270deg, #fffcfa 0%, #fff7f4 100%);
      border-radius: 14px;
      border: 1px solid #ffdfd1;
      font-weight: 400;
      font-size: 12px;
      color: #ff6c0e;
      text-align: left;
      margin-bottom: 8px;
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      padding-right: 14px;
      .questiontext_com {
        display: flex;
        align-items: center;
        justify-content: start;
        .jobName {
          max-width: 84px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .coName {
          max-width: 120px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-right: 8px;
        }
        .dot {
          width: 8px;
          text-align: center;
        }
      }
      .icon {
        width: 12px;
        height: 12px;
        margin: 0 6px 0 14px;
      }
      .com {
        background: url("../assets/img/activity/com.png");
        background-size: cover;
      }
      .job {
        background: url("../assets/img/activity/job.png");
        background-size: cover;
      }
    }
    .question {
      width: 100%;
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
      margin-bottom: 15px;
      .qst_icon {
        width: 16px;
        height: 16px;
        background: url("../assets/img/activity/question@3x.png");
        background-size: cover;
      }
      .qst_name {
        font-weight: 600;
        font-size: 18px;
        color: #222222;
        text-align: left;
        font-style: normal;
        margin-left: 8px;
        flex: 1;
      }
    }
    .qstarea {
      position: relative;
    }
    .qsttext {
      width: 100%;
      height: 135px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #dbdbdb;
      padding: 11px;
      padding-bottom: 20px;
      resize: none;
      font-weight: 400;
      font-size: 14px;
      color: #7c8087;
      line-height: 20px;
      text-align: left;
      overflow-y: scroll;
    }
    .answertext {
      height: 305px !important;
    }
    #myTextarea::-webkit-input-placeholder {
      background: url("../assets/img/activity/write.png") no-repeat left center;
      background-size: 13px 13px;
      padding-left: 14px;
    }

    #myTextarea:-moz-placeholder {
      background: url("../assets/img/activity/write.png") no-repeat left center;
      background-size: 10px 10px;
      padding-left: 14x;
    }

    #myTextarea::-moz-placeholder {
      background: url("../assets/img/activity/write.png") no-repeat left center;
      background-size: 10px 10px;
      padding-left: 14px;
    }

    #myTextarea:-ms-input-placeholder {
      background: url("../assets/img/activity/write.png") no-repeat left center;
      background-size: 10px 10px;
      padding-left: 14px;
    }
    .wordlimit {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #7c8087;
      background: #ffffff;
    }
    .guess {
      width: 100%;
      height: 22px;
      font-weight: 500;
      font-size: 16px;
      color: #222222;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      margin-top: 12px;
    }
  }
  .guest_con {
    margin: 0 16px 0 8px;
    height: 122px;
    .guessList {
      display: inline-block;
      margin-left: 8px;
      .g_item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 28px;
        background: #e2f2ff;
        border: 1px solid #e2f2ff;
        border-radius: 14px;
        font-weight: 400;
        font-size: 12px;
        color: #0091df;
        line-height: 17px;
        text-align: left;
        line-height: 28px;
        margin-top: 8px;
        .g_item_text {
          max-width: 307px;
          padding-right: 7px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .g_icon {
        width: 12px;
        height: 12px;
        background: url("../assets/img/activity/ask.png");
        background-size: cover;
        margin-left: 9px;
        margin-right: 4px;
      }
    }
  }
}
</style>
